import type { GetWorstWear } from './types';

const getWorstWear: GetWorstWear = ({ units }) => {
    const percents = units
        .map(({ percentRemaining }) => percentRemaining)
        .filter((percentRemaining): percentRemaining is number => percentRemaining !== null);

    return percents.length ? Math.min(...percents) : null;
};

export default getWorstWear;
